module.exports = __webpack_public_path__ + "img/icon-1.6500e67e.png";